import { Tooltip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ReactComponent as DefectSvg } from "assets/icons/defects.svg";
import ColourConstants from "helpers/colourConstants";

// defects.svg is fill="#fff" for use on the sidebar's red circular backdrop -
// override to commonBorder to match the other list indicator icons. The
// barrier glyph is solid-filled while sibling indicators (e.g. has-images)
// are thin outlines, so at full strength it reads darker despite the same
// colour - the opacity evens out the perceived weight.
const useStyles = makeStyles()(() => ({
	icon: {
		display: "inline-flex",
		opacity: 0.85,
		"& path": {
			fill: ColourConstants.commonBorder,
		},
	},
}));

const DefectStatusIcon = ({ label = "Defect", tooltip }) => {
	const { classes } = useStyles();
	const icon = (
		<span className={classes.icon}>
			<DefectSvg width={20} height={20} role="img" aria-label={label} />
		</span>
	);
	return tooltip ? <Tooltip title={tooltip}>{icon}</Tooltip> : icon;
};

export default DefectStatusIcon;
